// extracted by mini-css-extract-plugin
export default {"title":"PgLmpoqxnOSaPe9AH5wDYA==","list":"fvwCfW8vDWMMemphgkg59w==","list-item":"-Tmuc19x-l2xrpelFO8NZA==","image":"sEOu5CyGiHFAHQwc6Hv1Xg=="};